import React, { useState } from "react";
import { validateLoggedIn, getSession } from "../utils";
import { Paper, Typography, Box, Button, CircularProgress, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavBar from "../navbar";
import config from "../config";
import * as Sentry from "@sentry/react";
import UserRestrictionFields, { emptyRestriction, toPayload } from "./UserRestrictionFields";

const CreateUserRestriction = () => {
    const navigate = useNavigate();
    const [data, setData] = useState(emptyRestriction());
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const validate_logged_in = validateLoggedIn();
    if (validate_logged_in) return validate_logged_in;

    const handleChange = (field, value) => setData({ ...data, [field]: value });

    const handleSave = async () => {
        try {
            setSaving(true); setError(null);
            if (!data.endpoint_id.trim()) { setError("Endpoint ID is required"); setSaving(false); return; }
            if (!data.user_id.trim()) { setError("User ID is required"); setSaving(false); return; }
            const response = await fetch(config.apiBaseUrl + "/admin/endpoint-user-restrictions", {
                method: "POST",
                headers: { "Content-Type": "application/json", "user-authorization": getSession().token },
                body: JSON.stringify(toPayload(data)),
            });
            if (!response.ok) { const err = await response.json(); throw new Error(err.detail || `Error: ${response.status}`); }
            setSuccess(true);
            setTimeout(() => navigate("/endpoint-user-restrictions"), 1500);
        } catch (err) {
            Sentry.captureException(err); setError(err.message);
        } finally { setSaving(false); }
    };

    return (
        <>
            <NavBar />
            <Box sx={{ maxWidth: 900, margin: "auto", padding: 3 }}>
                <Paper sx={{ padding: 3 }}>
                    <Typography variant="h5" gutterBottom>Create User Restriction</Typography>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    {success && <Alert severity="success" sx={{ mb: 2 }}>Restriction created!</Alert>}
                    <UserRestrictionFields data={data} onChange={handleChange} saving={saving} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
                        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving} startIcon={saving && <CircularProgress size={16} />}>
                            {saving ? "Saving..." : "Create Restriction"}
                        </Button>
                        <Button variant="outlined" color="error" onClick={() => navigate("/endpoint-user-restrictions")} disabled={saving}>Cancel</Button>
                    </Box>
                </Paper>
            </Box>
        </>
    );
};

export default CreateUserRestriction;
